import React, { useState } from 'react';
import toastStyle from '../components/ToastMessage/ToastMessage.module.css'; // Replace with the correct path to your toast style
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined';


const useToast = () => {
    const [showToastMessage, setShowToastMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastMessageType, setToastMessageType] = useState("");

    const showToast = (type, message) => {
        setToastMessage(message);
        setToastMessageType(type);
        setTimeout(() => {
            setShowToastMessage(true);
        }, 500);
        

        setTimeout(() => {
            setShowToastMessage(false);
        }, 8000);
    };

    const Toast = () => {
        switch (toastMessageType.toLowerCase()) {
            case "success":
                return showToastMessage ? (
                    <div className={`${toastStyle.success} ${toastStyle.toastMain}` }>
                        <span>
                            <CheckCircleOutlineOutlinedIcon/>
                        </span>
                        <h5>
                            {toastMessage}
                            </h5>
                    </div>
                ) : null;
            case "error":
                return showToastMessage ? (
                    <div className={`${toastStyle.error} ${toastStyle.toastMain}`}>
                         <span>
                            <HighlightOffOutlinedIcon/>
                        </span>
                        <h5>
                            {toastMessage}
                            </h5>
                    </div>
                ) : null;
            case "caution":
                return showToastMessage ? (
                    <div className={`${toastStyle.caution}  ${toastStyle.toastMain}`}>
                        <span>
                            <ReportGmailerrorredOutlinedIcon/>
                        </span>
                        <h5>
                            {toastMessage}
                            </h5>
                    </div>
                ) : null;
            default:
                return null; // Return null for unknown type
        }
    };

    return { showToast, Toast };
};

export default useToast;